import React from 'react';
import { Check, Loader2, AlertCircle } from 'lucide-react';

interface AutosaveIndicatorProps {
  isSaving: boolean;
  lastSaved?: Date | null;
  error?: Error | null;
}

export const AutosaveIndicator: React.FC<AutosaveIndicatorProps> = ({
  isSaving,
  lastSaved,
  error,
}) => {
  if (error) {
    return (
      <div className="flex items-center text-red-600 text-sm">
        <AlertCircle className="w-4 h-4 mr-1" />
        <span>Failed to save</span>
      </div>
    );
  }

  if (isSaving) {
    return (
      <div className="flex items-center text-gray-600 text-sm">
        <Loader2 className="w-4 h-4 mr-1 animate-spin" />
        <span>Saving...</span>
      </div>
    );
  }

  if (lastSaved) {
    const timeAgo = getTimeAgo(lastSaved);
    return (
      <div className="flex items-center text-green-600 text-sm">
        <Check className="w-4 h-4 mr-1" />
        <span>Saved {timeAgo}</span>
      </div>
    );
  }

  return null;
};

function getTimeAgo(date: Date): string {
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
  
  if (seconds < 5) return 'just now';
  if (seconds < 60) return `${seconds} seconds ago`;
  
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;
  
  return 'over a day ago';
}